import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: "copied",
  class: "flex flex-col items-center"
}
const _hoisted_3 = {
  key: "copy",
  class: "flex flex-col items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "share-call-to-action",
    title: _ctx.$dictionary.get('global/generic/clipboardcopy'),
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.copy && _ctx.copy(...args)), ["prevent"]))
  }, [
    _createVNode(_Transition, {
      name: "o-anim-fade-300",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.pending)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createVNode(_component_c_icon, {
                name: "icon-checkmark-medium",
                class: "mb-20 w-30 h-30 xl:w-40 xl:h-40"
              }),
              _createElementVNode("span", null, _toDisplayString(_ctx.$dictionary.get('global/generic/clipboardcopyconfirm')), 1)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _createVNode(_component_c_icon, {
                name: "icon-some-link",
                class: "mb-20 w-30 h-30 xl:w-40 xl:h-40"
              }),
              _createElementVNode("span", null, _toDisplayString(_ctx.$dictionary.get('global/generic/clipboardcopy')), 1)
            ]))
      ]),
      _: 1
    })
  ], 8, _hoisted_1))
}